import {
  URLAPI,
  SOCIETIES_PATH,
  SOCIETY_CREATE_PATH,
  SOCIETY_UPDATE_PATH,
} from "../config/index";
import { LOGOUT } from './users'
import axios from "axios";

const init = {
  _get_all_societies: {
    data: [],

    status: 0,
    message: {},
  },

  _create_society: {
    data: {},
    status: 0,
    message: {},
  },
  _update_society: {
    data: {},
    status: 0,
    message: {},
  },
};

const GET_ALL_SOCIETIES = "GET_ALL_SOCIETIES";
export const CREATE_SOCIETY = "CREATE_SOCIETY";
export const UPDATE_SOCIETY = "UPDATE_SOCIETY";

export const societies_module = (state = init, action) => {
  switch (action.type) {
    case GET_ALL_SOCIETIES:
      return {
        ...state,
        _get_all_societies: action.payload,
      };
    case CREATE_SOCIETY:
      return {
        ...state,
        _create_society: action.payload,
      };
    case UPDATE_SOCIETY:
      return {
        ...state,
        _update_society: action.payload,
      };
    case LOGOUT:
      return init;
    default:
      return state;
  }
};

export const getAllSocieties = (token) => async (dispatch) => {
  try {
    const response = await axios.get(`${URLAPI}${SOCIETIES_PATH}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    });
    dispatch({
      type: GET_ALL_SOCIETIES,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: GET_ALL_SOCIETIES,
        payload: {
          data: [],
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: GET_ALL_SOCIETIES,
        payload: {
          data: [],
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const createSociety = (token, data) => async (dispatch) => {
  try {
    let form = new FormData();

    for (var key in data) {
      form.append(key, data[key]);
    }
    const response = await axios.post(
      `${URLAPI}${SOCIETY_CREATE_PATH}`,
      form,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    dispatch({
      type: CREATE_SOCIETY,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: CREATE_SOCIETY,
        payload: {
          data: {},
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: CREATE_SOCIETY,
        payload: {
          data: {},
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const updateSociety = (token, id, data) => async (dispatch) => {
  try {
    let form = new FormData();

    for (var key in data) {
      form.append(key, data[key]);
    }
    const response = await axios.patch(
      `${URLAPI}${SOCIETY_UPDATE_PATH}${id}/`,
      form,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    dispatch({
      type: UPDATE_SOCIETY,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: UPDATE_SOCIETY,
        payload: {
          data: {},
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: UPDATE_SOCIETY,
        payload: {
          data: {},
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const clear_societies = (type) => async (dispatch) => {
  dispatch({
    type: type,
    payload: {
      data: [],
      status: 0,
      message: {},
    },
  });
};
